// import * as firebase from "firebase";
//
// import { FirebaseConfig } from "../config/keys";
// firebase.initializeApp(FirebaseConfig);
//
// // const databaseRef = firebase.database().ref();
// // export const todosRef = databaseRef.child("todos");
// export const authRef = firebase.auth();
// export const provider = new firebase.auth.GoogleAuthProvider();


// TODO GITIGNORE THIS FILE!!!
export const credentials = {
  apiKey: 'AIzaSyBe4rRvTyLGP5dyylk2n3eE0yjqNxAGQaU',
  authDomain: 'pollpals-62e61.firebaseapp.com',
  // databaseURL: 'https://pollpals-62e61.firebaseio.com',
  projectId: 'pollpals-62e61',
  // storageBucket: 'pollpals-62e61.appspot.com',
  // messagingSenderId: '1025453969855'
};



// WEBPACK FOOTER //
// ./src/config/firebase.js